export default "__VITE_ASSET__BBNoR2jl__"